import { memo } from 'react';
import SOFQuestionCheckbox from './SOFQuestionCheckbox/SOFQuestionCheckbox';
import { SOFQuestionCheckboxesProps } from './SOFQuestionCheckboxes.types';
import { Box, Text, Icon } from '@betty/moonlight';

function SOFQuestionCheckboxes({
  questionId,
  options = [],
  answers,
  error,
  onChange,
  onAdditionalTextChange,
  inputRef,
  onSubmitEditing,
}: SOFQuestionCheckboxesProps) {
  return (
    <Box>
      {options.map(({ controlId, text, inputType }) => (
        <SOFQuestionCheckbox
          key={controlId}
          text={text}
          questionId={questionId}
          controlId={controlId}
          answers={answers}
          inputType={inputType}
          onValue={onChange}
          onAdditionalTextChange={onAdditionalTextChange}
          inputRef={inputRef}
          onSubmitEditing={onSubmitEditing}
          error={error}
        />
      ))}
      {error?.major ? (
        <Box flexDirection="row" alignItems="center" marginTop="space-100">
          <Icon
            name="errorOutline"
            color="darkSurfaceError"
            width={20}
            height={20}
          />
          <Text variant="caption" color="darkSurfaceError">
            {error.major}
          </Text>
        </Box>
      ) : null}
    </Box>
  );
}

export default memo(SOFQuestionCheckboxes);
